import PropTypes from 'prop-types';
import React from 'react';

import { EXCLUDED_IDS_FOR_LINKED_CONVERSATIONS } from 'src/pages/DocumentationIndex/constants';

import LinkedConversationsModule from '../LinkedConversationsModule';
import LinkedVsitsModule from '../LinkedVsitsModule';

const CommonModules = (props) => {
  const hasSelectedTemplate = !!props.templates.find((template) => template.isSelected);
  if (!hasSelectedTemplate) return null;

  const shouldHideLinkedConversations = props.templates.some(
    (template) =>
      template.isSelected && EXCLUDED_IDS_FOR_LINKED_CONVERSATIONS.includes(template.templateType),
  );

  return (
    <>
      {!shouldHideLinkedConversations && <LinkedConversationsModule {...props} />}
      <LinkedVsitsModule {...props} />
    </>
  );
};

CommonModules.propTypes = {
  templates: PropTypes.arrayOf(PropTypes.object),
};

export default CommonModules;
